import { FieldInsights } from "@/types/fieldInsights";
import { Field } from "@/types/field";
import { User } from "@/types/user";
import { ViewType } from "@/types/enums";

export function isFieldTrial(field: FieldInsights | Field, user: User) {
    return field.users?.find((view) => view.user_id === user.id && view.view_type === ViewType.Trial) ? true : false;
}